import type { CivilDate } from '@klopotun/domain';
import { useBankStateQuery } from '../../../entities/bank/index.js';
import { usePaymentsQuery } from '../../../entities/payment/index.js';

const NEXT_YEAR_STEP = 1;

const yearOfText = (value: string): number => Number(value.slice(0, 4));

const yearsBetween = (first: number, last: number): number[] =>
  Array.from({ length: last - first + 1 }, (_slot, index) => first + index);

export const usePeriodYears = (today: CivilDate, shownYear: number): number[] => {
  const bank = useBankStateQuery();
  const payments = usePaymentsQuery();
  const accounts = bank.data?.connection?.accounts ?? [];
  const historyYears = accounts.flatMap((account) =>
    account.isTracked && account.historyFrom !== null ? [yearOfText(account.historyFrom)] : [],
  );
  const paymentYears = (payments.data ?? []).map((payment) => yearOfText(payment.startDate));
  const firstYear = Math.min(today.year, shownYear, ...historyYears, ...paymentYears);
  const lastYear = Math.max(today.year + NEXT_YEAR_STEP, shownYear);

  return yearsBetween(firstYear, lastYear);
};
